import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'add_cards_to_list_form';
export const useAddCardsToListFormTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    toast_create_list_error: 'Не удалось создать список',
    new_list_button: 'Новый список',
    submit_button_add: 'Добавить',
    submit_button_move: 'Перенести',
    cancel_button: 'Отмена',
    title_add: 'Добавить в список',
    title_move: 'Перенести в список',
    subtitle: 'При переносе карточка исключается из текущего списка',
    select_placeholder: 'Выберите список',
    input_placeholder: 'Укажите название',
    input_label: 'Название нового списка',
    department_label: 'Подразделение владелец',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    toast_create_list_error: 'Failed to create list',
    new_list_button: 'New list',
    submit_button_add: 'Add',
    submit_button_move: 'Move',
    cancel_button: 'Cancel',
    title_add: 'Add to list',
    title_move: 'Move to list',
    subtitle: 'The card is removed from the current list when moved',
    select_placeholder: 'Select a list',
    input_placeholder: 'Enter a name',
    input_label: 'New list name',
    department_label: 'Owner department',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    toast_create_list_error: 'Não foi possível criar a lista',
    new_list_button: 'Nova lista',
    submit_button_add: 'Adicionar',
    submit_button_move: 'Mover',
    cancel_button: 'Cancelar',
    title_add: 'Adicionar à lista',
    title_move: 'Mover para a lista',
    subtitle: 'Ao realizar a transferência, o cartão é excluído da lista atual',
    select_placeholder: 'Selecione uma lista',
    input_placeholder: 'Digite um nome',
    input_label: 'Nome da nova lista',
    department_label: 'Departamento proprietário',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    toast_create_list_error: 'No se pudo crear la lista',
    new_list_button: 'Nueva lista',
    submit_button_add: 'Añadir',
    submit_button_move: 'Mover',
    cancel_button: 'Cancelar',
    title_add: 'Añadir a la lista',
    title_move: 'Mover a la lista',
    subtitle: 'Al transferir, la tarjeta se excluye de la lista actual',
    select_placeholder: 'Seleccione una lista',
    input_placeholder: 'Introduzca un nombre',
    input_label: 'Nombre de la nueva lista',
    department_label: 'Departamento propietario',
  },
}) : {}) as Record<string, unknown>;
